var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLbp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2755_4571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2755_4571)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 0H0V5.75H23V0ZM23 17.25H0V23H23V17.25Z",
    fill: "#F50101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.75H23V17.25H0V5.75Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4638 11.9917C15.5173 12.8229 13.2168 11.6469 13.2168 11.9797C13.2168 12.3125 15.6813 12.8968 15.6771 13.6419C15.673 14.3869 12.7549 13.4293 13.4093 13.7643C14.0637 14.0994 15.4687 14.9014 15.309 15.4011C14.9679 16.4682 12.7028 14.6608 12.5144 15.0171C12.2103 15.5919 14.1859 16.9325 14.1692 17.0606C14.137 17.3063 12.8199 16.6745 12.5144 17.1847C12.267 17.0916 12.1527 16.6475 12.0759 16.5886L11.5898 8.22872C11.5898 8.22872 12.0262 16.0999 11.4685 16.3263C10.9108 16.5527 9.3616 17.2409 9.31652 16.8972C9.29974 16.7691 11.1819 15.5919 10.8779 15.0171C10.6539 14.5936 8.38254 16.0956 8.23762 15.2258C7.59206 14.6053 10.3283 14.0684 10.3283 13.4339C10.3283 12.7993 7.82516 14.185 8.12461 13.3016C8.42405 12.4183 10.428 12.102 10.4654 11.9797C10.5337 11.756 8.23762 12.328 8.23762 11.9797C8.23762 11.3207 9.61199 11.191 10.4654 10.5979C10.5158 9.9211 8.39515 11.2642 8.23762 10.7216C8.08009 10.1791 10.9481 8.77358 10.8779 8.66409C10.7669 8.49117 8.45542 9.27142 8.83661 8.86168C9.57643 8.06646 11.0205 6.98509 11.3528 6.69664C11.3528 6.69664 11.3928 6.58781 11.4356 6.62475C11.4784 6.58781 11.5255 6.54736 11.5255 6.54736C11.5255 6.54736 11.5255 7.22781 11.5184 6.69664C11.5114 6.16548 14.9035 8.48969 14.942 9.07888C14.9868 9.76719 12.846 8.55997 12.8964 9.23676C13.3316 9.59625 14.5693 10.292 15.0807 10.5979C15.3127 10.7366 13.3717 10.3042 13.4127 10.5165C13.5171 11.0576 15.4079 11.1248 15.4638 11.9917Z",
    fill: "#52AB0B"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2755_4571)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_4571",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbp);
export default __webpack_public_path__ + "static/media/LBP.5d867d3f9a9fc3dd6d73b5b8bec6f9da.svg";
export { ForwardRef as ReactComponent };